






































import type { Lesson } from '@/models/lesson';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import AppliedLessonContainer from './AppliedLessonContainer.vue';
import AppliedLessonContainerHeader from './AppliedLessonContainerHeader.vue';
import type { User } from '@/models/user';
import { sortLessons } from '@/helpers/sortLessons';
import type { AppliedLessonsFilter } from '@/helpers/AppliedLessonsFilter';

@Component({
    name: 'AppliedLessonsList',
    methods: { sortLessons },
    components: {
        AppliedLessonContainer,
        AppliedLessonContainerHeader,
    },
})
export default class AppliedLessonsList extends Vue {
    @Prop() private lessons: Lesson[];
    @Prop() private level: number;
    @Prop() private tableColumns: AppliedLessonsFilter;
    @Prop() private root: boolean;
    @Prop() private isUpdating: boolean;
    @Prop({ required: false }) private highlight: number | null;

    @Prop({
        required: false,
    })
    private expandEverything: boolean;

    @Getter('account/userInfo') private userInfo: User;

    private haveSubLessons(lesson: any) {
        return lesson.sub_lessons && lesson.sub_lessons.length > 0;
    }

    private toggleUpdateAppliedLessonModal(value) {
        this.$emit('toggleUpdateAppliedLessonModal', value);
    }
}
